
import React from 'react'
import Slider from '../Components/Slider'
import Services from '../Components/Services'
import Categories from '../Components/Categories'
import Testimonials from '../Components/Testimonials'
import Faq from '../Components/Faq'
const Home = () => {
  return (
    <div>
    <Slider/>
    <Categories/>
    <Services/>
    <Testimonials/>
    
    </div>
  )
}

export default Home